
const PREFIX = ''
export default {
  // 通过type查询value值 查询枚举
  POST_SPS_SYS_ENUM_URL(data, params) {
    return this.fetch({ methods: 'post', url: PREFIX + '/app-lscm/sys/enum/findValueByType', data: data, params: params })
  },
  // 搜索供应商
	VENDORMASTER(data, params) {
		return this.fetch({ methods: 'post', url: '/app-lscm/supplier/findPage', data: data, params: params })
	},
  // 搜索开发员
	FIND_LIST_BY_FUZZY_NAME(data, params) {
		return this.fetch({ methods: 'post', url: '/app-scm-plugin/ad/user/findListByFuzzyName', data: data, params: params })
	},
  // 查询特征值[颜色-尺码组]
	DIMENSION_GROUP_URL(data, params) {
		return this.fetch({ methods: 'post', url: '/app-lscm/sys/findFeatureList', data: data, params: params })
	},
  // // 分页查询供应商信息
	// QUERY_SUPPLIER_FIND(data, params) {
	// 	return this.fetch({ methods: 'post', url: '/app-lscm/supplier/findPage', data: data, params: params })
	// },

	//【发货预约】模糊查询人员

	POST_APPOINT_MEMBER_LIST(data, params) {
                
		return this.fetch({methods: 'post', url: PREFIX + '/app-scm-plugin/ad/user/findListByFuzzyName', data: data, params: params})
	 
	},
}
